module.exports = __webpack_public_path__ + "img/clipboard-data.06685949.svg";